import React, { useState, useEffect } from 'react';
import './../styles/AndroidInstallPage.css';
import DOMPurify from 'dompurify';
import { useAuth } from '../context/AuthContext';
import visorService from './../services/VisorService';
import DocumentService from './../services/DocumentService';
import onePng from './../assets/images/one-40.png';
import twoPng from './../assets/images/two-40.png';
import alert from './../assets/images/alert-40.png';
import read from './../assets/images/reading-40.png';
import greenTick from './../assets/images/green-tick.png';
import getBaseUrl from './../utils/baseUrl';
import DownloadButton from './Buttons/DownloadButton';

function AndroidInstallPage() {
  const { token, androidApk } = useAuth();
  const [isAndroid, setIsAndroid] = useState(false);
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);
  const [visorId, setVisorId] = useState('');
  const [visorCreated, setVisorCreated] = useState(false);
  const { constabulary } = useAuth();
  const { groupId } = useAuth();
  const [documents, setDocuments] = useState([]);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [htmlContent1, setHtmlContent1] = useState('');
  const [htmlContent2, setHtmlContent2] = useState('');
  const [paragraph1, setParagraph1] = useState('');
  const [paragraph2, setParagraph2] = useState('');

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      setIsAndroid(true);
    }
  }, []);

  useEffect(() => {
    const fetchDocuments = async () => {
      try {
        const docs = await DocumentService.getDocuments(token, 'Android');
        setDocuments(docs);
        if (docs.length > 0) {
          const firstDocument = docs[0];
          setSelectedDocument(firstDocument);
        }
      } catch (error) {
        console.error('Failed to fetch documents:', error);
      }
    };

    fetchDocuments();
  }, [token]);

  const handleCreateVisor = async () => {
    if (!visorId.trim()) {
      setError("Visor ID cannot be empty.");
      setVisorCreated(false);
      return;
    }

    try {
      const result = await visorService.createVisor(token, visorId);
      setResponse(result);
      setVisorId("");
      setVisorCreated(true);
      setError(null);
    } catch (error) {
      setError(error.message);
      setVisorCreated(false);
    }
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    const sanitizedValue = value.replace(/[^a-zA-Z0-9-]/g, '');
    setVisorId(sanitizedValue);
    if (value !== sanitizedValue) {
      setError('Only alphanumeric characters and hyphens are allowed.');
    } else {
      setError(null);
    }
  };

  const loadHtmlContent = async (fileName, setContentFunction) => {
    try {
      const response = await fetch(`${getBaseUrl()}/guides/android/${fileName}`);
      if (!response.ok) {
        throw new Error(`Failed to fetch the HTML file. Status: ${response.status}`);
      }
      const htmlText = await response.text();
      const sanitizedHtml = DOMPurify.sanitize(htmlText);
      setContentFunction(sanitizedHtml);
    } catch (error) {
      console.error('Error loading the HTML file:', error);
      setContentFunction('<p>Error loading content. Please try again later.</p>');
    }
  };

  useEffect(() => {
    loadHtmlContent('android1.html', setHtmlContent1);
    loadHtmlContent('android2.html', setHtmlContent2);
    loadHtmlContent('android3.html', setParagraph1);
    loadHtmlContent('android4.html', setParagraph2);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="android-main-content">
      <div className="android-home-line"></div>
      <main>
        <div className="android-line-container">
          <img src={alert} alt="Step 1" className="android-step-number" />
          <div className="android-content">
            <div className="html-content" dangerouslySetInnerHTML={{ __html: htmlContent1 }} />
          </div>
        </div>
        <div className="android-line-container">
          <img src={onePng} alt="Step 1" className="android-step-number" />
          <div className="android-content">
            <h2 className="android-title">Install eSafe on Android</h2>
            <div className="html-content" dangerouslySetInnerHTML={{ __html: paragraph1 }} />
            <div className="input-button-container">
              <input
                id="userInput"
                className="android-input-field"
                type="text"
                placeholder="Enter your visor ID"
                value={visorId}
                onChange={handleInputChange}
              />
              <button className="android-create-button" title="Create" onClick={handleCreateVisor}>Create Visor ID</button>
              {visorCreated && <img src={greenTick} alt="Success" className="success-tick" />}
            </div>
            {error && <div className="error-message">{error}</div>}
          </div>
        </div>
        <div className="android-line-container">
          <img src={twoPng} alt="Step 2" className="android-step-number" />
          <div className="android-content">
            <div className="html-content" dangerouslySetInnerHTML={{ __html: paragraph2 }} />            
            <DownloadButton className="android-button" link={androidApk} title={`Download APK`} />
          </div>
        </div>
        <div className="android-line-container">
          <img src={read} alt="read" className="android-step-number" />
          <div className="android-content">
            <div className="html-content" dangerouslySetInnerHTML={{ __html: htmlContent2 }}></div>
          </div>
        </div>
        <button onClick={scrollToTop} className="top-button">Top</button>
      </main>
    </div>
  );
}

export default AndroidInstallPage;
